$(function () {
  $('#prefecture_id').change(function (e) {
    const $municipalitySelect = $('#application_municipality_id')

    const prefectureId = $('option:selected', this).val()
    if (prefectureId) {
      $municipalitySelect.prop('disabled', false)
      updateMunicipalitySelectOptions(prefectureId)
    } else {
      $municipalitySelect.prop('disabled', true)
      $municipalitySelect.empty()
    }
  })
})

function updateMunicipalitySelectOptions(prefectureId) {
  const $municipalitySelect = $('#application_municipality_id')
  $municipalitySelect.empty()

  $municipalitySelect.append($('<option>').html('選択してください'))
  gon.municipalities[prefectureId].forEach(function (municipality) {
    $municipalitySelect.append($('<option>').html(municipality.name).val(municipality.id))
  })
}
